import React from 'react';
import ReactCodeInput from 'react-code-input';

interface PinSectionProps {
  pinUpdated: (pin: string) => void;
  confirmPinUpdated: (pin: string) => void;
  pin: string;
  confirmPin: string;
}

const PinSection = ({
  pinUpdated,
  confirmPinUpdated,
  pin,
  confirmPin,
}: PinSectionProps) => {
  return (
    <div className="my-2 d-flex flex-column justify-content-center">
      <p>
        To configure a pin code for quicker sign in, please set it below. <br />{' '}
        If not required then just leave the pin fields blank.
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: '15px',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '280px', textAlign: 'center' }}>
          <p>Optional PIN for sign in</p>
          <ReactCodeInput
            name="4-pin"
            inputMode="numeric"
            onChange={pinUpdated}
            fields={4}
            type="password"
          />
        </div>

        <div style={{ width: '280px' }}>
          <p>Confirm optional PIN</p>
          <ReactCodeInput
            name="4-pin-confirm"
            inputMode="numeric"
            isValid={pin === confirmPin}
            onChange={confirmPinUpdated}
            fields={4}
            type="password"
          />
        </div>
      </div>
    </div>
  );
};

export default PinSection;
